import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import style from './index.less';
import EventIcon from './event-icon';

const MessageSensitiveWords = props => {
  const { data, handleReEdit } = props;
  const { content, time, action, rawContent, isEdit } = data;

  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={classnames(style.header)}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>
          <span>{content}</span>
          {isEdit ? (
            <>
              <span> </span>
              <a onClick={() => handleReEdit(rawContent)}>{'重新编辑'}</a>
            </>
          ) : null}
        </li>
      </ul>
    </div>
  );
};

export default MessageSensitiveWords;
